// extracted by mini-css-extract-plugin
export default {"Space--fullWidth":"Space_Space--fullWidth__VVqe+"};